import React__default, { memo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';
import { StyledEndAdornment, StyledIconPlaceholder, StyledContainerTypeCounter } from './InputFieldAdornment.styles.js';
import { TYPE } from '../constants/common.js';

var InputFieldAdornment = /*#__PURE__*/memo(function (_ref) {
  var value = _ref.value,
    type = _ref.type;
    _ref.size;
    var handleClean = _ref.handleClean,
    endAdornment = _ref.endAdornment,
    endAdornmentSize = _ref.endAdornmentSize,
    maxLength = _ref.maxLength;
  var renderCounter = function renderCounter() {
    return /*#__PURE__*/React__default.createElement(StyledContainerTypeCounter, {
      className: "input-field-adornment"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "current-length"
    }, value.length), /*#__PURE__*/React__default.createElement("span", {
      className: "slash"
    }, "/"), /*#__PURE__*/React__default.createElement("span", {
      className: "max-length"
    }, maxLength));
  };
  if (endAdornment) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, maxLength && renderCounter(), " ", /*#__PURE__*/React__default.createElement(Box, {
      ml: 1
    }, endAdornment));
  }
  switch (type) {
    case TYPE.SEARCH:
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, maxLength && renderCounter(), /*#__PURE__*/React__default.createElement(Box, {
        ml: 1
      }, !isEmpty(value) ? /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(StyledEndAdornment, {
        onClick: handleClean,
        fontSize: endAdornmentSize
      }, /*#__PURE__*/React__default.createElement(CloseIcon, null))) : /*#__PURE__*/React__default.createElement(StyledIconPlaceholder, null)));
    default:
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, maxLength && renderCounter());
  }
});
InputFieldAdornment.propTypes = {
  value: PropTypes.string.isRequired,
  handleClean: PropTypes.func,
  type: PropTypes.oneOf(Object.values(TYPE)),
  size: PropTypes.oneOf(['extraLarge', 'large', 'medium', 'small', 'extraSmall', 'extraSmallSmall']),
  endAdornment: PropTypes.node,
  endAdornmentSize: PropTypes.number,
  maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
InputFieldAdornment.defaultProps = {
  type: TYPE.DEFAULT,
  size: 'extraLarge',
  endAdornment: null,
  handleClean: function handleClean() {},
  endAdornmentSize: 20,
  maxLength: null
};
var InputFieldAdornment$1 = InputFieldAdornment;

export { InputFieldAdornment$1 as default };
